import { registerSW } from 'virtual:pwa-register';

/**
 * Service worker kaydı ELLE yapılıyor (`injectRegister: null`).
 *
 * Sebep: güncellemenin NE ZAMAN uygulanacağına uygulama karar veriyor.
 * `updateSW()` sayfayı yeniden yüklüyor; maçın ortasında çalışsaydı oyun
 * kaybolurdu. `App` yalnızca masadan uzaktayken uyguluyor.
 */

let apply: (() => Promise<void>) | null = null;
let ready: (() => void) | null = null;
let pending = false;

const update = registerSW({
  immediate: true,
  onNeedRefresh() {
    pending = true;
    ready?.();
  },
});

apply = async () => {
  await update(true);
};

export function onUpdateReady(callback: () => void): void {
  ready = callback;
  if (pending) callback();
}

export function applyUpdate(): void {
  void apply?.();
}
